import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "room-header" }

import { BookingCalendar } from "../calendar";
import { useMasterDataHelpers } from "../calendar/composables/useMasterDataHelpers";
import RoomNavigator from "./components/RoomNavigator.vue";
import RoomNavigatorSkeleton from "./components/RoomNavigatorSkeleton.vue";
import { computed } from "vue";


export default {
  __name: 'RoomBookingCalendar',
  props: {
	roomId: { type: Number, required: true },
	roomName: { type: String, required: true },
	roomBookingApiUrl: { type: String, required: true },
	userApiUrl: { type: String, required: true },
	dashboardUrl: { type: String, required: true },
},
  setup(__props) {

const props = __props;

const roomName = computed(() => props.roomName + " - Raumbuchungen");

// Use master data helpers for navigation
const masterData = useMasterDataHelpers();

// Handle room navigation
function handleRoomNavigation(newRoomId) {
	// Navigate to the new room by changing the URL
	const currentPath = window.location.pathname;
	const basePathMatch = currentPath.match(/^(.+\/calendar\/)\d+/);
	
	if (basePathMatch) {
		const basePath = basePathMatch[1];
		window.location.href = basePath + newRoomId;
	} else {
		// Fallback: construct URL from current location
		window.location.href = `/room-booking/calendar/${newRoomId}`;
	}
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createCommentVNode(" Room title and navigation "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, _toDisplayString(roomName.value), 1 /* TEXT */),
      _createCommentVNode(" Show skeleton while loading, then real navigation when loaded "),
      (!_unref(masterData).isLoaded.value)
        ? (_openBlock(), _createBlock(RoomNavigatorSkeleton, { key: 0 }))
        : _createCommentVNode("v-if", true),
      _createVNode(_unref(BookingCalendar), {
        "room-id": __props.roomId,
        "room-name": roomName.value,
        "room-booking-api-url": __props.roomBookingApiUrl,
        "user-api-url": __props.userApiUrl,
        mode: "single-room"
      }, {
        toolbar: _withCtx(({ filterSelector }) => [
          (_unref(masterData).isLoaded.value)
            ? (_openBlock(), _createBlock(RoomNavigator, {
                key: 0,
                "current-room-id": __props.roomId,
                buildings: _unref(masterData).buildingsList.value,
                "all-rooms": _unref(masterData).allRooms.value,
                "rooms-by-building": _unref(masterData).roomsByBuilding.value,
                "dashboard-url": __props.dashboardUrl,
                onNavigateToRoom: handleRoomNavigation
              }, {
                default: _withCtx(() => [
                  (filterSelector.show)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(filterSelector.component), _mergeProps({ key: 0 }, filterSelector.props, _toHandlers(filterSelector.events)), null, 16 /* FULL_PROPS */))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["current-room-id", "buildings", "all-rooms", "rooms-by-building", "dashboard-url"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["room-id", "room-name", "room-booking-api-url", "user-api-url"])
    ])
  ]))
}
}

}